import {AfterViewInit, Component, ElementRef, Input, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {ImageService} from '../../../services/image.service';
import {DialogService} from '../../../services/dialog.service';
import {environment} from '../../../environments/environment';

declare var gtag;
declare var ga;

@Component({
  selector: 'app-scan',
  templateUrl: './scan.component.html',
  styleUrls: ['./scan.component.scss']
})
export class ScanComponent implements OnInit, AfterViewInit{
  @ViewChild('canvas') public canvas!: ElementRef;
  @ViewChild('cameraBtn') public cameraBtn!: ElementRef;
  // tslint:disable-next-line:no-output-rename
  @Output('subtitleClick') subtitleClick = new EventEmitter();
  // tslint:disable-next-line:no-input-rename
  @Input('mode') mode;
  checkScanProgress;


  barCodeMsg = '';
  videoElement;
  scanFailure = false;
  vidWidth = 0;
  vidHeight = 0;
  credentials = {};
  helpTxt = 'Position the page within 4 white corners and take a picture';
  isCamera = false;
  isImage = false;
  imageId = '';
  torch = false;
  scanProgress = false;
  showSubtitle = false;
  bookDetails: any = [];
  isFlash = false;

  disableScanProgress = false;
  searchSubscribe: any;
  fetchSubscribe: any;

  flashHelpTxt = 'Turn on Flash';
  isImageCapture = false;

  constructor(private elementRef: ElementRef,
              private dialogService: DialogService,
              private imageService: ImageService){
  }


  ngAfterViewInit(): void{
    this.vidWidth = window.innerWidth;
    this.vidHeight = window.innerHeight;
    // this.setBorderHeight();
    window.addEventListener('offline', () => {
      this.dialogService.hideDialog();
      this.dialogService.showDialog('NETWORK');
    });
    // document.documentElement.requestFullscreen()
    //   .catch((fullscreenErr) => console.log(fullscreenErr));
    if (this.mode) {
      this.focusCameraBtn();
    }
  }


  ngOnInit(): void{
    this.videoElement = document.getElementsByTagName('video')[0];

    if (this.mode === 'back') {
      this.bookDetails = this.imageService.getBookDetails();
      this.showSubtitle = true;
      this.toggleScan(false);
    }

    if (typeof gtag !== 'undefined') {
      gtag('config', environment.google_analytics_id, {
        custom_map: {dimension2: 'action'}
      });

      // Sends an event that passes 'action' as a parameter.
      gtag('event', 'action_dimension', {action: 'Scan Page'});
    }

    this.dialogService.openDialog$.subscribe((res) => {
      if (this.scanProgress) {
        this.cancelScan();
      }
      this.focusCameraBtn();
    });
    this.isImageCapture = (typeof ImageCapture !== 'undefined') ? true : false;
  }

  focusCameraBtn(): void{
    setTimeout(() => {
      if (this.cameraBtn) {
        const btn = this.cameraBtn.nativeElement as HTMLButtonElement;
        btn.focus();
      }
    }, 2000);
  }

  cameraLoaded(evt, msg): void{
    this.isCamera = (msg) ? true : false;
  }

  /*
  * Scan QR Code , if QR code is not available then scan image
  *
  * */
  scanComplete(evt, msg): void{
    if (msg) {
      window.location = evt;
    } else {
      if (!this.scanFailure && this.vidWidth > 0) {
        this.scanFailure = true;
      }
    }
  }

  /*
  * Check If Flash / Torch is compatible with current OS/Browser
  * */
  checkFlash(evt: any): void{
    this.imageService.appHasFlash = this.isFlash = (evt) ? true : false;
  }

  /*
  *Toggle the Flash / Torch facility if availble
  * */
  toggleFlash(): void{
    this.torch = !this.torch;
    this.flashHelpTxt = (this.torch) ? 'Turn off Flash' : 'Turn on Flash';
  }

  /*
  * if image is getting scanned, If Image Capture API is available then
  * process with API otherwise proceed with canvas
  * */
  capture(): void{
    if (this.scanProgress) {
      return;
    }

    this.dialogService.showDialog('SCAN_PROGRESS');
    this.disableScanProgress = false;
    this.scanProgress = true;
    if (this.isImageCapture) {
      const track = this.videoElement.srcObject.getVideoTracks()[0];
      const imageCapture = new ImageCapture(track) as any;
      imageCapture.takePhoto().then(blob => createImageBitmap(blob))
        .then(imageBitmap => {
          this.uploadImage(imageBitmap);
        });
    } else {
      this.uploadImage(this.videoElement);
    }
  }

  /**
   * Search Image API if match is found then process with Image Details otherwise,
   * Show Alert Match is not found
   */
  uploadImage(image): void{
    const can = this.canvas.nativeElement;
    can.width = 1280; // can.width = this.vidWidth;
    can.height = 720; // can.height = this.vidHeight;
    const context = can.getContext('2d');
    context.drawImage(image, 0, 0, can.width, can.height);
    const dataURL = can.toDataURL('image/png');
    const blob = this.dataURItoBlob(dataURL);
    // const imageFileName = `scan-image-${new Date().toISOString()}.png`;
    const img = new Image();
    img.src = window.URL.createObjectURL(blob);
    const dataURLStr = dataURL.replace('data:image/png;base64,', '');
    this.scanProgress = true;
    this.checkScanProgress = setTimeout(() => {
      if (this.scanProgress) {
        this.cancelScan();
        this.toggleDialog('TIME_OUT');
      }
    }, 30000);
    this.searchSubscribe = this.imageService.searchImage(dataURLStr).subscribe((result) =>
      this.searchImage(result), this.handleError);
  }

  /*
  * If match is not found  show "Match not found", otherwise fetch asset
  *  details and provide links based on the details
  * */
  searchImage(result): void{
    console.log(' result from searchImage -->', result);
    if (!this.disableScanProgress) {
      if ((result.status_code === 500) || (result.invalid_response === true)) {
        clearTimeout(this.checkScanProgress);
        this.toggleDialog('NOT_FOUND');
        this.scanProgress = false;
      } else {
          this.imageId = result[0].ensemble_response_1.pdf_id;
          clearTimeout(this.checkScanProgress);
          // alert('Image ID -->' + this.imageId);
          this.isImage = true;
          const payload = {pdfid: this.imageId};

          this.fetchSubscribe = this.imageService
            .fetchImageDetails(payload)
            .subscribe((bookDetails) => this.fetchDetails(bookDetails), this.handleError);
      }
    }
  }

  /*
  * Show asset links as buttons over the camera if match is found
  * otherwise show Match Not found
  * */
  fetchDetails(bookDetails): void{
    if (!this.disableScanProgress) {
      this.scanProgress = false;
      this.bookDetails = bookDetails.project_details;
      this.bookDetails.forEach(bookDetail => this.parseJSON(bookDetail[0]));
      this.imageService.setBookDetails(this.bookDetails);
      if (this.bookDetails.length === 0) {
        this.toggleDialog('NOT_FOUND');
      } else {
        this.dialogService.hideDialog();
        this.toggleScan(false);
      }
    }
  }

  /*
  * Cancel Scan, when cancel button is clicked on the progress dialog
  * */
  cancelScan(): void{
    this.scanProgress = false;
    clearTimeout(this.checkScanProgress);
    if (this.searchSubscribe) {
      this.searchSubscribe.unsubscribe();
    }
    if (this.fetchSubscribe) {
      this.fetchSubscribe.unsubscribe();
    }
    this.disableScanProgress = true;
  }

  /*
  * If API response fails , then something went wrong message will be displayed
  * */
  handleError(): void{
    this.toggleDialog('WENT_WRONG');
  }

  /*
  * Toggle the help text / instruction text based on the Scan or Asset Link Page
  * */
  toggleScan(isTrue: boolean): void{
    if (isTrue) {
      this.helpTxt = 'Position the page within 4 white corners and take a picture';
      this.showSubtitle = false;
      this.focusCameraBtn();
    } else {
      this.showSubtitle = true;
      this.helpTxt = 'Click a content link to view it in the viewer';
    }
    // this.setBorderHeight();
  }

  /*
    *  Close existing dialog and show new dialog
    * */
  toggleDialog(str): void{
    this.dialogService.hideDialog();
    this.dialogService.showDialog(str);
  }

  /*
  *  Load existing asset on clicking asset link
  * */
  navigateToURL(imageDetail): void{
    this.subtitleClick.emit(imageDetail);
  }

  /*
   * Convert Image Data URI to blob for searching image
   *  */
  dataURItoBlob(dataURI: any): any{
    const byteString = atob(dataURI.toString().split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], {type: 'image/png'});
    return blob;
  }

  /*
  * Parse asset link Image
  * */
  parseJSON(bookDetail): object{
    bookDetail.asset = JSON.parse(bookDetail.assets);
    bookDetail.asset[0].desc = (bookDetail.asset[0].desc && bookDetail.asset[0].desc.length > 0) ? bookDetail.asset[0].desc : '';
    return bookDetail.asset;
  }
}
